import Phaser from 'phaser';
import { create } from './create';
import { preload } from './preload';
import { update } from './update';

const w =  480 * 2;
const h =  852 * 2;

// var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
var config = {
	type: Phaser.AUTO,
	width: w, height: h,
	audio: {
		disableWebAudio: false //iOS
	},
	scale: {
		parent: 'game-target',
		autoCenter: Phaser.Scale.CENTER_HORIZONTALLY,
		mode: Phaser.Scale.FIT,
		width: w, height: h,
	},
	pixelArt: false,
	images: {missing: new Phaser.Core.Config().defaultImage},
	physics: {
		default: 'matter',
		matter: {}
	},
	callbacks: {
		postBoot: function (game) {	}
	},
	scene: {
		preload: preload,
		create: create,
		update: update
	}
};


export function phaserMain(width, height){
	const m = window.manager;
	let oldAsp = config.width/config.height;
	let newAsp = width/height;

	if(oldAsp < newAsp){
		//new is wider than old
		config.width = (config.height * width) / height;
	} else {
		config.height = (config.width * height) / width;
	}
	config.scale.width = config.width;
	config.scale.height = config.height;
	config.transparent = true;

	m.calcDimensions({
		width: config.width,
		height: config.height
	});

	console.log('config', config);
	m.game = window.game = new Phaser.Game(config);
	m.game.sound.pauseOnBlur = false;
	console.log('NEW PHASER GAME');
}